import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#8A9A5B',       // Sage Leaf
      light: '#A8B87B',
      dark: '#6B7A42',
      contrastText: '#0B2027',
    },
    secondary: {
      main: '#B87333',       // Copper Root
      light: '#D4924D',
      dark: '#9A5F22',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F0F4F4',    // Mist
      paper: '#ffffff',
    },
    text: {
      primary: '#0B2027',    // Night Forest
      secondary: '#2A4A55',
    },
    warning: {
      main: '#B87333',
    },
    info: {
      main: '#B87333',
    },
    divider: 'rgba(11, 32, 39, 0.12)',
  },
  typography: {
    fontFamily: '"Manrope", "Helvetica Neue", sans-serif',
    h1: {
      fontFamily: '"Space Grotesk", "Helvetica Neue", sans-serif',
      fontWeight: 700,
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: '"Space Grotesk", "Helvetica Neue", sans-serif',
      fontWeight: 600,
      lineHeight: 1.15,
    },
    h3: {
      fontFamily: '"Space Grotesk", "Helvetica Neue", sans-serif',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: '"Space Grotesk", "Helvetica Neue", sans-serif',
      fontWeight: 500,
      lineHeight: 1.25,
    },
    h5: {
      fontFamily: '"Space Grotesk", "Helvetica Neue", sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Space Grotesk", "Helvetica Neue", sans-serif',
      fontWeight: 500,
    },
    body1: {
      lineHeight: 1.75,
    },
    body2: {
      lineHeight: 1.65,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background:
            'radial-gradient(circle at top, rgba(11,32,39,0.07), transparent 60%), radial-gradient(circle at 30% 10%, rgba(184,115,51,0.07), transparent 45%), #F0F4F4',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          letterSpacing: '0.01em',
          borderRadius: 999,
          paddingInline: 20,
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#A8B87B',
          },
        },
        outlinedPrimary: {
          borderColor: 'rgba(138, 154, 91, 0.4)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          border: '1px solid rgba(11, 32, 39, 0.08)',
          boxShadow: '0 10px 30px rgba(11, 32, 39, 0.08)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 999,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(11, 32, 39, 0.96)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 12px 30px rgba(11, 32, 39, 0.28)',
          color: '#F0F4F4',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#ffffff',
        },
        notchedOutline: {
          borderColor: 'rgba(11, 32, 39, 0.14)',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(11, 32, 39, 0.1)',
        },
      },
    },
  },
})

export default theme
